var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsEnum, IsOptional, IsString, ValidateNested } from 'class-validator';
import { Role } from '../roles/enums/role.enum.js';
import { CaregiverRelationship } from '../user/enums/caregiver.enum.js';
/**
 * Refusal code when a request names no office and the Account has Persons in
 * several (#1822). The server never picks one.
 */
export const OFFICE_SELECTION_REQUIRED = 'OFFICE_SELECTION_REQUIRED';
/**
 * Refusal code when the office a request names doesn't resolve to one Person of
 * the Account (#1822). One answer whatever the reason: never the Account's,
 * just unlinked, or more than one live row. A caregiver entry that doesn't
 * resolve gets it too (#1841). The frontend drops its stored choice on it and
 * continues as after login.
 */
export const OFFICE_NOT_AVAILABLE = 'OFFICE_NOT_AVAILABLE';
/** Query parameter that names the Active office on cookie-authenticated media URLs. */
export const OFFICE_ID_QUERY_PARAM = 'officeId';
/**
 * A patient the Account acts for in an office, through a caregiver entry with
 * registered access (#1841): one context of the switcher („Max Muster · Elternteil“).
 */
export class AccountCaregiverEntryDto {
    /** The entry's id: what `X-Therame-Caregiver-Id` names. */
    id;
    patientFirstName;
    patientLastName;
    relationship;
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], AccountCaregiverEntryDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], AccountCaregiverEntryDto.prototype, "patientFirstName", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], AccountCaregiverEntryDto.prototype, "patientLastName", void 0);
__decorate([
    Expose(),
    IsEnum(CaregiverRelationship),
    __metadata("design:type", String)
], AccountCaregiverEntryDto.prototype, "relationship", void 0);
/**
 * One office in which the Account has a Person that resolves, or a caregiver
 * entry with registered access (`GET /auth/offices`, #1841). An Office has no
 * name of its own, so the name and picture are the Person's location's
 * (TM-9665): a patient's current location, or a staff member's allowed ones
 * („Physio Nord + 1“). In an office with only entries, the first patient's.
 */
export class AccountOfficeDto {
    id;
    name;
    /** The Account's Person's role in this office; null when it acts here only for others. */
    role;
    /** Filename of that location's profile image. */
    profileImage;
    /** The patients the Account acts for here, through entries with registered access. */
    caregiverEntries;
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], AccountOfficeDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], AccountOfficeDto.prototype, "name", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsEnum(Role),
    __metadata("design:type", Object)
], AccountOfficeDto.prototype, "role", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], AccountOfficeDto.prototype, "profileImage", void 0);
__decorate([
    Expose(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => AccountCaregiverEntryDto),
    __metadata("design:type", Array)
], AccountOfficeDto.prototype, "caregiverEntries", void 0);
//# sourceMappingURL=active-office.js.map